import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { MixedInsumos, Substituicao } from './types';

interface TabTalhoesProps {
  selectedInsumoObjects: MixedInsumos[];
  substituicoes: Record<string, Substituicao>;
  onToggleTalhao: (insumoId: string, talhaoId: string) => void;
  onSalvar: () => void;
}

const TabTalhoes: React.FC<TabTalhoesProps> = ({
  selectedInsumoObjects,
  substituicoes,
  onToggleTalhao,
  onSalvar,
}) => (
  <div className="assistente-talhoes">
    <table className="assistente-table assistente-table-talhoes">
      <thead>
        <tr>
          <th>Substituir</th>
          <th>Por</th>
          <th>nos Talhões/Tratamentos</th>
        </tr>
      </thead>
      <tbody>
        {selectedInsumoObjects.map((insumo) => {
          const substituicao = substituicoes[insumo.id];
          const unidadeAbreviatura =
            substituicao?.unidade && insumo.unidadesCompativeis
              ? insumo.unidadesCompativeis.find(
                  (unidade) => String(unidade.id) === substituicao.unidade,
                )?.abreviatura ?? ''
              : '';
          const talhoes = insumo.talhoes ?? [];

          const unidadeInsumo =
            insumo.unidadesCompativeis?.[0]?.abreviatura?.trim();

          return (
            <tr key={insumo.id}>
              <td className="assistente-table-col-source">
                {`${insumo.nome}${unidadeInsumo ? `/${unidadeInsumo}` : ''}`}
              </td>
              <td className="assistente-table-col-dest">
                {substituicao?.porDescricao
                  ? `${substituicao.porDescricao}${
                      unidadeAbreviatura ? ` ${unidadeAbreviatura}/ha` : ''
                    }`
                  : '-'}
              </td>
              <td className="assistente-table-col-talhoes">
                {talhoes.map((talhao) => (
                  <div key={talhao.id} className="assistente-talhoes-item">
                    <Checkbox
                      inputId={`talhao-${insumo.id}-${talhao.id}`}
                      checked={
                        substituicao?.talhoes.includes(String(talhao.id)) ??
                        false
                      }
                      onChange={() =>
                        onToggleTalhao(insumo.id, String(talhao.id))
                      }
                    />
                    <label htmlFor={`talhao-${insumo.id}-${talhao.id}`}>
                      {talhao.descricao}
                    </label>
                  </div>
                ))}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>

    <div className="assistente-talhoes-footer">
      <Button
        label="Salvar"
        className="assistente-btn-salvar"
        onClick={onSalvar}
      />
    </div>
  </div>
);

export default React.memo(TabTalhoes);
